import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ModalService } from '@app/components/modal/modal.service';
import { ModalRendererComponent } from './modelRenderer.component';

/**
 * ModalComponent
 *
 * Can be opened with: `this.modal.open(AnyCustomComponent, { userId: 123 }, { screen: 'full' });`
 *
 * The opened component can implmenet these parameters to receive data:
 *  @Input() data: any;
 *  @Input() close: (() => void) | undefined;
 * (the close prop is the handed in close function)
 *
 */
@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, ModalRendererComponent],
  template: `
    @for (modal of modalService.allModals(); track modal) {
      <app-modal-renderer [modal]="modal" />
    }
  `,
})
export class ModalComponent {
  modalService = inject(ModalService);
}
